import React from 'react'
import dayjs from 'dayjs'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_AdviserProfileEducation.scss'
import * as commonStyles from '../../../common/_common.scss'
import { modificationStates } from '../../../common/ReducerHelperFunctions/listDifferenceComputer'
import PropTypes from 'prop-types';

class AdviserProfileEducation extends React.Component {

  static propTypes = {
    qualifications: PropTypes.array,
    editor: PropTypes.bool,
    comparison: PropTypes.bool,
    hideDeleted: PropTypes.bool,
    editingIndex: PropTypes.number,
    children: PropTypes.oneOfType([
      PropTypes.node, 
      PropTypes.arrayOf(PropTypes.node)
    ])
  };

  constructor (props) {
    super(props)
    this.renderEducationAndQualifications = this.renderEducationAndQualifications.bind(this)
  }

  createModificationClass (modificationState) {
    switch (modificationState) {
      case modificationStates.added:
        return commonStyles['item-added']
      case modificationStates.deleted:
        return commonStyles['item-deleted']
      case modificationStates.modified:
        return commonStyles['field-was-modified']
    }

    return ''
  }

  render () {
    // eslint-disable-next-line no-unused-vars
    const { qualifications, editor, editingIndex, comparison, hideDeleted, children, ...props } = this.props
    const noQualifications = 'Not specified'
    return (
      <div className={styles['education']} {...props}>
        <h4 className={styles['title']}> Education and qualifications</h4>
        {(qualifications || []).map(this.renderEducationAndQualifications)}
        {(qualifications || []).length <= 0 && <p>{noQualifications}</p>}
      </div>
    )
  }

  renderEducationAndQualifications (educationOrQualification, index) {
    // While an admin is editing the pending profile, a deleted qualification should
    // disappear from the list (matching the normal editor). In the read-only comparison
    // view it stays visible with the struck-through "deleted" styling so reviewers can
    // still see what was removed.
    if (this.props.hideDeleted && educationOrQualification.modificationState === modificationStates.deleted) {
      return null
    }
    if (this.props.editor && index === this.props.editingIndex) {
      return this.props.children
    }

    var modificationStyle = this.props.comparison ? this.createModificationClass(educationOrQualification.modificationState) : ''

    return <div key={index}>
      <h4 className={styles['education-description'] + ' ' + modificationStyle}>{educationOrQualification.description} {this.props.children && (!this.props.editor || this.props.comparison) ? this.props.children[index] : ''}</h4>
      <h5 className={styles['education-institution'] + ' ' + modificationStyle}>{educationOrQualification.institution}</h5>
      <p className={styles['education-institution-period-of-study'] + ' ' + modificationStyle}>
        { dayjs(educationOrQualification.studyStartDate).format('MMM YYYY')}
        <span>&nbsp;-&nbsp;</span>
        {educationOrQualification.studyEndDate !== null && dayjs(educationOrQualification.studyEndDate).format('MMM YYYY')}
        {educationOrQualification.studyEndDate === null && 'Present'}
      </p>
    </div>
  }

}

export default (AdviserProfileEducation)
